import { render, staticRenderFns } from "./AgendaEvent.vue?vue&type=template&id=7a3482b9"
import script from "./AgendaEvent.vue?vue&type=script&lang=js"
export * from "./AgendaEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports